import React, { useEffect, useState } from "react";
import { handleToastClose } from "../../store/actions/layoutActions";
import { makeStyles } from "@material-ui/core/styles";
// import moment from "moment";
import {
  Grid,
  Card,
  Button,
  IconButton,
  withWidth,
  Snackbar,
  Tooltip,
} from "@material-ui/core";
import {
  KeyboardArrowUp,
  KeyboardArrowDown,
  Close,
  BookmarkBorderSharp,
} from "@material-ui/icons";
import {
  onSetUnStakeAmount,
  onAllowedUnstake,
  onSetPhnxUsdValue,
  setAvailableAmount,
  setEarlyUnstakeAmount,
  setStakes,
  onUnStakePhnx,
} from "../../store/actions/unstakeActions";
import { getContractBalance } from "../../store/actions/dashboardActions";
import { PHNX_STAKING_ADDRESS } from "../../contracts/phnxStaking";
import { connect } from "react-redux";
import Web3 from "web3";
import { truncateValue } from "../../utils";
import Arrow from "../../Assets/arrow.svg";
import DownArrow from "../../Assets/arrowDown.svg";
import spinner from "../../Assets/spinner-black.svg";

const dummyData = {
  user: {
    stake: [
      {
        altQuantity: "1000000000000000000",
        durationTimestamp: "86400",
        id: "1623936766",
      },
      {
        altQuantity: "100000000000000000000",
        durationTimestamp: "31536000",
        id: "1635411238",
      },
      {
        altQuantity: "50000000000000000000",
        durationTimestamp: "2592000",
        id: "1635508098",
      },
      {
        altQuantity: "200000000000000000000",
        durationTimestamp: "8640000",
        id: "1635509996",
      },
    ],
  },
};

const useStyles = makeStyles((theme) => ({
  myCard: {
    background: theme.palette.card.main,
    height: "100%",
    padding: "32px",
    borderRadius: "8px",
  },

  unstakeinput: {
    marginTop: "8px",
    background: theme.palette.primary.main,
    color: theme.palette.text.primary,
    borderRadius: "23px",
    border: "inherit",
    height: "80px",
    width: "100%",
    fontSize: "1.5rem",
    outline: "none",
    paddingLeft: 25,
  },

  myPara: {
    fontSize: 16,
    "@media (min-width: 2400px)": {
      fontSize: 24,
    },

    "@media (max-width : 1400px)": {
      fontSize: 12,
    },
  },

  myHeading: {
    fontSize: 24,
    "@media (min-width: 2400px)": {
      fontSize: 36,
    },
  },

  maxButton: {
    fontSize: 14,
    "@media (min-width: 2400px)": {
      fontSize: 20,
    },
  },

  arrowButton: {
    "&:hover": {
      transform: "none !important",
      boxShadow: "none !important",
    },
  },

  btnConfirm: {
    background: "#EA8604",
    color: "white",
    height: "60px",
    borderRadius: "16px",
  },
}));

const Unstake = (props) => {
  const classes = useStyles();
  const [amount, setAmount] = useState();
  const [amountFocus, setAmountFocus] = useState(false);
  const [stakedPhnx, setStakedPhnx] = useState("");
  const [lockedPHNX, setLockedPHNX] = useState([]);
  const [burningPHNX, setBurningPHNX] = useState("");
  const [availablePhnx, setAvailablePhnx] = useState(0);
  const themeMode = localStorage.getItem("themeMode");
  const [emptyContractBalanceWarning, setEmptyContractBalanceWarning] =
    useState(false);

  const [localEarlyStakePhnx, setLocalEarlyStakePhnx] = useState(0);
  const [data, setData] = useState(null);
  const [usdValue, setUsdValue] = useState(0);

  useEffect(() => {
    if (props.network != 1) {
      setData(null);
      return;
    }
    if (props.dashboardData) {
      setData(props.dashboardData);
    }
  }, [props.dashboardData]);

  useEffect(() => {
    if (amount && props.phnxUsdValue) {
      if (truncateValue(amount * props.phnxUsdValue) == 0) {
        setUsdValue("");
      } else {
        setUsdValue(truncateValue(amount * props.phnxUsdValue));
      }
    } else {
      setUsdValue("");
    }
  }, [amount, props.phnxUsdValue]);

  useEffect(() => {
    props.onSetPhnxUsdValue();
    const _interval = setInterval(props.onSetPhnxUsdValue, 60000);
    return () => clearInterval(_interval);
  }, []);

  // stakedPhnx
  useEffect(() => {
    if (data && data.user) {
      const stakedPhnx = data.user?.stake
        ?.map((_stake) => parseFloat(Web3.utils.fromWei(_stake.altQuantity)))
        .reduce((a, b) => a + b, 0);

      setStakedPhnx(stakedPhnx);
      props.setStakes(data?.user?.stake);
    }
  }, [props.balance, data, props.unStakeLoading]);

  // Available Phnx
  const calculateAvailablePhnx = () => {
    if (props.network != 1) {
      props.setAvailableAmount(0);
      setAvailablePhnx(0);
      return;
    }
    if (data && data.user) {
      if (props.dashboardData?.user?.stake?.length < 1) {
        setAvailablePhnx(0);
        return;
      }

      const availablePhnx = props.dashboardData?.user?.stake
        ?.filter(
          (_stake) =>
            parseFloat(_stake.initiationTimestamp) +
              parseFloat(_stake.durationTimestamp) <=
            Date.now() / 1000
        )
        .map((_stake) => parseFloat(Web3.utils.fromWei(_stake.altQuantity)))
        .reduce((a, b) => a + b, 0);

      props.setAvailableAmount(availablePhnx);
      setAvailablePhnx(availablePhnx);
    }
  };

  useEffect(() => {
    calculateAvailablePhnx();
  }, [
    props.balance,
    data,
    props.dashboardData,
    props.network,
    props.address,
    props.dashboardData,
  ]);

  useEffect(() => {
    if (data && data.user && data.user?.stake?.length > 0) {
      //calculate burn here
      let burnAmount = 0;
      let _amount = Number(props.unstakeAmount) - Number(availablePhnx);

      data.user.stake.map((_stake, i) => {
        // console.log("data", _stake.altQuantity);

        let timestamp = Math.floor(+new Date() / 1000);
        let initiationTimestamp = Number(_stake.initiationTimestamp);
        let durationTimestamp = Number(_stake.durationTimestamp);
        let altQuantity = Web3.utils.fromWei(String(_stake.altQuantity));
        altQuantity = Number(altQuantity);

        if (initiationTimestamp + durationTimestamp >= timestamp) {
          let _remainingTime =
            durationTimestamp + initiationTimestamp - timestamp;
          let _totalTime = durationTimestamp;
          if (_amount >= altQuantity) {
            let stakeBurn = _calculateBurn(
              altQuantity,
              _remainingTime,
              _totalTime
            );
            burnAmount = burnAmount + stakeBurn;
            _amount = _amount - altQuantity;
            altQuantity = 0;
          } else if (_amount < altQuantity && _amount > 0) {
            altQuantity = altQuantity - _amount;
            let stakeBurn = _calculateBurn(_amount, _remainingTime, _totalTime);
            burnAmount = burnAmount + stakeBurn;
            _amount = 0;
          }
        } else {
          // console.log("else");
          // _amount = _amount - altQuantity;
          if (_amount >= altQuantity) {
            _amount = _amount - altQuantity;
            altQuantity = 0;
          } else if (_amount < altQuantity && _amount > 0) {
            altQuantity = altQuantity - _amount;
          }
        }
      });

      // console.log("burnAmount---->", burnAmount);
      setBurningPHNX(burnAmount);
    }
  }, [data, props.unstakeAmount, localEarlyStakePhnx]);

  const _calculateBurn = (_amount, _remainingTime, _totalTime) => {
    const burnAmount = (_amount * _remainingTime) / _totalTime;
    return burnAmount;
  };

  useEffect(() => {
    setAmount(props.unstakeAmount);
    var earlyUnstakingPHNXlocal = props.unstakeAmount - availablePhnx;
    setLocalEarlyStakePhnx(earlyUnstakingPHNXlocal);
    props.setEarlyUnstakeAmount(earlyUnstakingPHNXlocal);

    var burningPHNXLocal = 0;

    // locked Phnx will be zero if there is no item available for unstake, so I think this condition will automatically fail
    for (let _stake of lockedPHNX) {
      let remainingDays =
        (parseFloat(_stake.initiationTimestamp) +
          parseFloat(_stake.durationTimestamp) -
          Date.now() / 1000) /
        86400;
      let totalDays = parseFloat(_stake.durationTimestamp / 86400); // 86400 are 24hrs
      let quantity = parseFloat(Web3.utils.fromWei(_stake.altQuantity));

      if (
        earlyUnstakingPHNXlocal >=
        parseFloat(Web3.utils.fromWei(_stake.altQuantity))
      ) {
        burningPHNXLocal += (quantity * remainingDays) / totalDays;
        earlyUnstakingPHNXlocal -= quantity;
      } else {
        burningPHNXLocal +=
          (earlyUnstakingPHNXlocal * remainingDays) / totalDays;
        break;
      }
    }
  }, [props.unstakeAmount, availablePhnx]);

  const onChangeAmount = (e) => {
    if (props.unstakeLoading !== true) {
      if (
        e.target.value.match(/^(\d+\.?\d{0,4}|\.\d{1,4})$/) ||
        e.target.value == ""
      ) {
        if (
          e.target?.value <=
          Number(stakedPhnx.toString().match(/^-?\d+(?:\.\d{0,4})?/)[0])
        ) {
          setAmount(e.target.value);
          props.onUnstakeAmount(e.target.value);
        }
      }
    }
  };

  const onMaxClick = () => {
    // console.log(availablePhnx);
    setAmount(availablePhnx.toString().match(/^-?\d+(?:\.\d{0,4})?/)[0]);
    props.onUnstakeAmount(
      availablePhnx.toString().match(/^-?\d+(?:\.\d{0,4})?/)[0]
      // availablePhnx.toString()
    );
  };

  useEffect(() => {
    if (amount == 0) {
      setAmount("");
    }
  }, [amount]);

  useEffect(() => {
    props.getContractBalance(PHNX_STAKING_ADDRESS);
    // console.log("props.contractBalance", props.contractBalance);
  }, [props.balance]);

  const handleUnstake = () => {
    if (
      Number(props.contractBalance) <= 0 ||
      Number(amount) > Number(props.contractBalance)
    ) {
      setEmptyContractBalanceWarning(true);
      setTimeout(() => {
        setEmptyContractBalanceWarning(false);
      }, 4000);
      return;
    } else {
      // props.onUnStakePhnx(calculateAvailablePhnx, getDashboardData);
      props.onUnStakePhnx(calculateAvailablePhnx);
    }
  };

  return (
    <Card className={classes.myCard}>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        open={props.toastState}
        autoHideDuration={6000}
        onClose={props.onToastClose}
        message={props.toastMessage}
        action={
          <React.Fragment>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={props.onToastClose}
            >
              <Close fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />
      <Grid
        style={{ height: "100%" }}
        direction="column"
        justify="space-between"
        container
      >
        <Grid container item justify="space-between">
          <Grid item>
            <span className={classes.myHeading}>Unstaking</span>
          </Grid>
          <Grid item>
            <Button
              variant="outlined"
              className={classes.maxButton}
              style={{ border: "1px solid #5A5A5A" }}
              onClick={() => onMaxClick()}
            >
              Max
            </Button>
          </Grid>
          <Grid style={{ margin: "12px 0px" }} xs={12} item>
            <span className={classes.myPara} style={{ color: "#828282" }}>
              Enter the amount of PHNX you would like to Unstake
            </span>
          </Grid>
        </Grid>
        {/* <h2>{amount}</h2>
        <h2>{props.unstakeAmount}</h2> */}

        <Grid container item justify="space-between">
          <Grid style={{ position: "relative" }} xs={12} sm={3} md={3} item>
            <IconButton
              className={classes.arrowButton}
              onClick={() => {
                onChangeAmount({
                  target: { value: String(Number(amount) + 1) },
                });
                // setAmount(Number(amount) + 1);
              }}
              style={{ position: "absolute", right: 0, top: 24 }}
            >
              <KeyboardArrowUp />
            </IconButton>
            <IconButton
              className={classes.arrowButton}
              onClick={() => {
                if (amount !== 0) {
                  onChangeAmount({
                    target: { value: String(Number(amount) - 1) },
                  });
                  // setAmount(Number(amount) - 1);
                }
              }}
              style={{ position: "absolute", right: 0, top: 64 }}
            >
              <KeyboardArrowDown />
            </IconButton>
            <span
              className={classes.myPara}
              style={{ color: "#828282", marginLeft: "5px" }}
            >
              PHNX
            </span>
            <br />
            <Tooltip title="Type in the amount of $PHNX you will like to unstake or use the navigation tool by the right to increase or decrease the amount.">
              <input
                className={classes.unstakeinput}
                placeholder="0.0"
                value={amount}
                onChange={(e) => onChangeAmount(e)}
                disabled={props.unstakeLoading}
              />
            </Tooltip>
          </Grid>
          <Grid xs={12} sm={1} style={{ display: "flex" }} item>
            <img
              height="32"
              width="100%"
              style={
                props.width === "xs"
                  ? { margin: "12px 0px" }
                  : { margin: "auto", marginBottom: "25px" }
              }
              src={props.width === "xs" ? DownArrow : Arrow}
              alt="right arrow"
            />
          </Grid>
          <Grid xs={12} sm={3} md={3} item>
            <span
              className={classes.myPara}
              style={{ color: "#828282", marginLeft: "5px" }}
            >
              USD
            </span>
            <br />
            <Tooltip title="This is the current automated dollar estimate of the $PHNX amount inputted to unstake.">
              <input
                className={classes.unstakeinput}
                placeholder="0.0"
                value={usdValue}
                onChange={(e) => onChangeAmount(e)}
                disabled={true}
              />
            </Tooltip>
          </Grid>
          <Grid xs={12} sm={1} style={{ display: "flex" }} item>
            <img
              height="32"
              width="100%"
              style={
                props.width === "xs"
                  ? { margin: "12px 0px" }
                  : { margin: "auto", marginBottom: "25px" }
              }
              src={props.width === "xs" ? DownArrow : Arrow}
              alt="right arrow"
            />
          </Grid>
          <Grid xs={12} sm={3} md={3} item>
            <span
              className={classes.myPara}
              style={{ color: "#828282", marginLeft: "5px" }}
            >
              Approx Burned PHNX
            </span>
            <br />
            <Tooltip title="This is the amount of $PHNX that will be burnt assuming you are unstaking early before your stipulated unstaking time period.">
              <input
                className={classes.unstakeinput}
                placeholder="0.0"
                value={
                  burningPHNX > 0
                    ? burningPHNX.toString().match(/^-?\d+(?:\.\d{0,4})?/)[0]
                    : 0
                }
                disabled={true}
              ></input>
            </Tooltip>
          </Grid>
        </Grid>
        {emptyContractBalanceWarning && (
          <p style={{ color: "#eed202", marginTop: 10 }}>
            For now we can't perform this transaction try again very soon!
          </p>
        )}

        <Grid container item justify="space-between">
          <Grid
            xs={12}
            sm={12}
            item
            className={classes.myPara}
            style={{
              textAlign: "left",
              color: "#828282",
              fontWeight: "bold",
            }}
          >
            Available PHNX for unstake
          </Grid>
          <Grid
            xs={12}
            sm={12}
            item
            className={classes.myPara}
            style={{
              marginTop: "4px",
              textAlign: "left",
              color: "#828282",
              fontWeight: "bold",
            }}
          >
            <span
              style={
                themeMode === "dark" ? { color: "white" } : { color: "black" }
              }
            >
              {availablePhnx
                ? availablePhnx.toString().match(/^-?\d+(?:\.\d{0,4})?/)[0]
                : 0}{" "}
              PHNX
            </span>
          </Grid>
        </Grid>

        <Grid style={props.width === "xs" ? { marginTop: "12px" } : {}}>
          <Button
            variant="contained"
            size="large"
            className={classes.btnConfirm}
            style={{ height: "60px" }}
            onClick={handleUnstake}
            disabled={props.unstakeLoading || props.network != 1}
          >
            {props.unstakeLoading ? (
              <img src={spinner} />
            ) : (
              <span
                className={classes.myPara}
                style={{ textTransform: "none" }}
              >
                Confirm Unstake
              </span>
            )}
          </Button>
          {/* {unStakeLoading ? <p>{unstakeLoading?.toString()}</p> : null} */}
          {/* {props.unStakeLoading && <img src={spinner} />} */}
        </Grid>
      </Grid>
    </Card>
  );
};

const mapStateToProps = (state) => {
  return {
    toastMessage: state.layoutReducer.toastMessage,
    toastState: state.layoutReducer.toastState,
    address: state.layoutReducer.address,
    balance: state.dashboardReducer.balance,
    stakedPhnx: state.unstakeReducer.unstakeablePHNX,
    unstakeAmount: state.unstakeReducer.unstakeAmount,
    unstakeLoading: state.layoutReducer.unStakeLoading,
    interest: state.dashboardReducer.interest,
    phnxUsdValue: state.unstakeReducer.phnxUsdValue,
    contractBalance: state.dashboardReducer.contractBalance,
    network: state.layoutReducer.network,
    phnxAmount: state.stakeReducer.phnxAmount,

    onUnstakeConfirmationNumber:
      state.unstakeReducer.onUnstakeConfirmationNumber,

    dashboardData: state.dashboardReducer.dashboardData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onToastClose: () => dispatch(handleToastClose()),
    onUnstakeAmount: (amount) => dispatch(onSetUnStakeAmount(amount)),
    onAllowedUnstake: (allowed) => dispatch(onAllowedUnstake(allowed)),
    setAvailableAmount: (amount) => dispatch(setAvailableAmount(amount)),
    setEarlyUnstakeAmount: (amount) => dispatch(setEarlyUnstakeAmount(amount)),
    setStakes: (stakes) => dispatch(setStakes(stakes)),
    onSetPhnxUsdValue: () => dispatch(onSetPhnxUsdValue()),
    onUnStakePhnx: (calculateAvailablePhnx) =>
      dispatch(onUnStakePhnx(calculateAvailablePhnx)),
    getContractBalance: (address) => dispatch(getContractBalance(address)),
  };
};

export default withWidth()(
  connect(mapStateToProps, mapDispatchToProps)(Unstake)
);
